export default __webpack_public_path__ + "static/media/account-backup.302b7125.png";